<template>
   <div class="viewBonusLesson container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row margin-left-1Point6Perc">
                <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
                      {{getCurrentlySelectedCourseObj.CourseTitle}}
                </div>    
                <div class="col-md-5 col-lg-5">
                  <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="udpateCloseViewBonusLessonOverlay($event,false)">
                    <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row margin-left-1Point5Perc">
                  <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
                      {{lessonObj.Title}}
                  </div>    
              </div>
              <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
                  <div class="col-md-12 col-lg-12 text-align-left orange-text-color create-element-overlay-course-title-font-styles">
                    Associated Bonus Content: {{getBonusLessonObj.Title !== undefined && getBonusLessonObj.Title !== null ? getBonusLessonObj.Title : 'Not available' }}
                    <span><img :src="iconEdit" alt="iconEdit" class="img-responsive edit-img-width-height cursor-pointer display-inline" @click="selectedAction($event,'edit')"></span>
                    <span><img :src="iconDelete" alt="iconDelete" class="img-responsive edit-img-width-height cursor-pointer display-inline" @click="selectedAction($event,'delete')"></span>
                  </div>
              </div>
              <div class="row">
                <div class="col-md-2 col-lg-2 padding-right-0px text-align-left padding-left-4Point4 create-element-overlay-course-title-font-styles cursor-pointer" @click="openAddBonusVideoOverlay" v-bind:class="{'margin-bottom-2Perc': !showBonusList}">
                  <span class="glyphicon glyphicon-plus-sign"></span><span> Add New </span>
                </div>
                <div class="col-md-10 col-lg-10 padding-left-0px text-align-left cursor-pointer" v-bind:class="{'add-Opacity': bonusElemArrToCutPaste.length === 0}" @click="selectedAction($event,'cut_paste')">
                  <span class="glyphicon glyphicon-minus-sign"></span><span> Cut and Paste Video(s) into "<b><i>{{lessonObj.Title}}</i></b>" lesson</span>
                </div>
              </div>
              <div class="row margin-bottom-2Perc center" v-if="showBonusList">
                <bonus-video-gallery v-for="responseObj in bonusVideoArr" :key="responseObj.UserElementId" v-bind:bonusVideoObj="responseObj" @refreshList="getAllFiles" @selectedOperation="selectedOperation" @pushOrPopBonusObj="addOrRemoveBonusObjForCutPasteOperation"></bonus-video-gallery>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postfixString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="checkAndPerformOnConfrimationAction"></confirmation-alert>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
      </div>
      <!-- <loader></loader> -->
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div> 
</template>
<script>
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import iconDelete from '../../assets/images/delete.svg'
import iconEdit from '../../assets/images/edit.svg'
import { constants } from '@/utils/constants'
import { elementService } from '@/server-util/element-service'
import { bonusService } from '@/server-util/bonus-service'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import BonusVideoGallery from '@/components/view_element/BonusVideoGallery'
import { moduleService } from '@/server-util/module-service'
import findIndex from 'lodash/findIndex'
export default {
  props: ['lessonObj', 'elementObj', 'bonusLessonObj'],
  name: 'viewBonusLesson',
  created () {
    this.getBonusElementsList()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      bonusVideoArr: [],
      showBonusList: false,
      iconEdit: iconEdit,
      iconDelete: iconDelete,
      showConfirmationBox: false,
      prefixString: '',
      postfixString: '',
      bonusElemArrToCutPaste: []
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'bonus-video-gallery': BonusVideoGallery,
    'confirmation-alert': ConfirmationOverlay
  },
  methods: {
    checkAndPerformOnConfrimationAction (value) {
      this.showConfirmationBox = false
      if (value) {
        if (this.prefixString === 'The bonus lesson') {
          this.deleteSelectedLesson()
        } else {
          this.cutSelectedBonusVideos()
        }
      }
    },
    addOrRemoveBonusObjForCutPasteOperation (value) {
      const isSelected = value.isSelected
      const currBonusObj = value.selectedBonusObj
      const arrIndexPos = findIndex(this.bonusElemArrToCutPaste, (elementId) => {
        return elementId === currBonusObj.ElementId
      })
      var foundElementInArray = false
      if (arrIndexPos >= 0) {
        foundElementInArray = true
      } else {
        foundElementInArray = false
      }
      if (isSelected) {
        if (!foundElementInArray) {
          this.bonusElemArrToCutPaste.push(currBonusObj.ElementId)
        } else {
          console.log('isSelected true + Already present ElementId in array hence ignored adding into array')
        }
      } else {
        if (foundElementInArray) {
          this.bonusElemArrToCutPaste.splice(arrIndexPos, 1)
        } else {
          console.log('isSelected false hence ignored removing from array')
        }
      }
    },
    updateShowConfirmationAlertFlag (value) {
      this.showConfirmationBox = value
    },
    deleteSelectedLesson () {
      var _this = this
      var storeObj = this.$store
      if (
        this.getBonusElemObj.BonusModuleId !== undefined
      ) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        moduleService
          .deleteModule(storeObj.state.access_token, _this.getBonusElemObj.BonusModuleId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Refresh Lesson List
              _this.getLessons()
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected Lesson Object is NULL hence declined DELETE OPERATION'
        )
      }
    },
    cutSelectedBonusVideos () {
      var _this = this
      var storeObj = this.$store
      if (
        this.getBonusElemObj.BonusModuleId !== undefined
      ) {
        var selectedElementIdsInStr = this.bonusElemArrToCutPaste.join(',')
        var objToPass = {
          ToModuleId: _this.lessonObj.ModuleId,
          ElementIds: selectedElementIdsInStr
        }
        this.$store.state.isLoading = true
        bonusService
          .cutAndPasteBonusElements(storeObj.state.access_token, objToPass)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Reset/clear bonus element array which was used for cut paste
              _this.bonusElemArrToCutPaste = []
              // AK: Refresh Bonus Element List
              _this.getAllFiles()
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected Lesson Object is NULL hence declined DELETE OPERATION'
        )
      }
    },
    getLessons: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.selectedCourseObjFromFilter.CourseMasterId !== undefined
      ) {
        moduleService
          .listModules(
            storeObj.state.access_token,
            storeObj.state.selectedCourseObjFromFilter.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.selectedMasterClassModuleList = responseObj.data
              // AK: Hide Spinner after recieving updated Lesson list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              var obj = {
                closeOverlay: false,
                isUpdated: false
              }
              _this.$emit('closeOverlay', obj)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'CourseMasterId is NULL hence declined REFRESH LESSON LIST OPERATION'
        )
      }
    },
    selectedAction: function (event, operationToPerform) {
      switch (operationToPerform) {
        case 'edit':
          var obj = {
            selectedOperation: 'update_bonus_lesson',
            selectedElemObj: null,
            selectedBonusObj: this.getBonusLessonObj
          }
          // AK: Emit to ViewBonusLesson file for create operation
          this.$emit('selectedOperation', obj)
          break
        case 'delete':
          this.prefixString = 'The bonus lesson'
          this.postfixString = ' you are trying to delete is associated with \'' + this.getBonusElemObj.Title.substr(0, this.getBonusElemObj.Title.indexOf('-')) + '\' step. You must re-associate the \'' + this.getBonusElemObj.Title.substr(0, this.getBonusElemObj.Title.indexOf('-')) + '\' step with another bonus lesson again to make it work.'
          this.showConfirmationBox = true
          break
        case 'cut_paste':
          const selectedVideoArrLen = this.bonusElemArrToCutPaste.length
          if (selectedVideoArrLen > 0) {
            var postFixToJoin = selectedVideoArrLen === 1 ? ' video' : ' videos'
            this.prefixString = 'Are you sure you want to cut'
            this.postfixString = ' and paste selected ' + selectedVideoArrLen + postFixToJoin + ' into ' + this.lessonObj.Title + '?'
            this.showConfirmationBox = true
          }
          break
      }
    },
    openAddBonusVideoOverlay: function () {
      var obj = {
        selectedOperation: 'create',
        selectedElemObj: null,
        selectedBonusObj: this.getBonusLessonObj
      }
      // AK: Emit to ViewBonusLesson file for create operation
      this.$emit('selectedOperation', obj)
    },
    selectedOperation (value) {
      // AK: Re-emit elementlist file
      this.$emit('selectedOperation', value)
    },
    getAllFiles (value) {
      this.getBonusElementsList()
    },
    udpateCloseViewBonusLessonOverlay: function (event) {
      var obj = {
        closeOverlay: false,
        isUpdated: false
      }
      this.$emit('closeOverlay', obj)
    },
    getBonusElementsList: function () {
      // console.log('this.getBonusElemObj >>> ' + JSON.stringify(this.getBonusElemObj))
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      // alert(this.LessonObj.ModuleId)
      if (
        this.getBonusElemObj.BonusModuleId !== undefined ||
        this.getBonusElemObj.BonusModuleId !== null ||
        this.getBonusElemObj.length > 0
      ) {
        elementService
          .listElements(storeObj.state.access_token, this.getBonusElemObj.BonusModuleId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.bonusVideoArr = responseObj.data
              _this.showBonusList = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No bonus content found.'
                this.showBonusList = false
              } else {
                setTimeout(() => {
                  this.showBonusList = true
                }, 10)
              }
              // console.log('_this.bonusVideoArr >>> ' + JSON.stringify(_this.bonusVideoArr))
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'ModuleId is NULL hence declined LOADING ELEMENT LIST OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  computed: {
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    getBonusElemObj: {
      get: function () {
        return this.elementObj
      }
    },
    getBonusVideoArr: {
      get: function () {
        return this.bonusVideoArr
      }
    },
    getBonusLessonObj: {
      get: function () {
        return this.bonusLessonObj
      }
    },
    getBonusLessonTitle: {
      get: function () {
        return this.getBonusLessonObj.Title
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.edit-img-width-height {
  width: 1.5%;
  height: 1.5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.margin-right-1Perc{
  margin-right:1%;
}
.orange-text-color {
  color: #f39c12 !important;
}
.height-12Px{
 height:12px; 
}
.display-inline{
  display:inline;
}
.center {
    margin: auto;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
    margin-left:1.6%;
}
.border-red {
  border: 1px solid red;
}
.add-Opacity {
  cursor: default;
  opacity: 0.3;
}
</style>


// WEBPACK FOOTER //
// src/components/view_element/ViewBonusLesson.vue